import React from "react";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

/**
 * 403 Forbidden Page
 * Shows when a user tries to access a page without the required permissions.
 * @returns {JSX.Element}
 */
const Forbidden403 = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 2, sm: 4 },
        py: { xs: 4, sm: 8 },
        width: '100%',
        bgcolor: 'background.default',
      }}
    >
      <Paper elevation={0} sx={{ p: { xs: 3, sm: 5 }, borderRadius: 2, maxWidth: 420, mx: 'auto', width: '100%', textAlign: 'center' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
          <LockOutlinedIcon sx={{ fontSize: 62, color: 'primary.main', mb: 1, background: (theme) => theme.palette.primary.light, borderRadius: '50%', p: 1.5 }} />
          <Typography variant="h4" fontWeight={700} color="primary.main" gutterBottom>
            Oops! No Access
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 2 }}>
            This page is restricted.
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
          You don’t have permission to view this page.<br />
          If you think you should have access, please contact your system administrator or support team.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{ mt: 1, px: 4, borderRadius: 3, fontWeight: 600 }}
          onClick={() => navigate("/admin")}
        >
          Return to Dashboard
        </Button>
      </Paper>
    </Box>
  );
};

export default Forbidden403;
